module.exports = __webpack_public_path__ + "static/success.45711eca.svg";